module.exports = __webpack_public_path__ + "img/s_whiteblackM-logo.c1828af.png";